﻿import { GroCommon, UploadImageModule } from './common';

$(document).ready(function () {
    var facilityEditOpeningHoursPage = new FacilityEditOpeningHoursPage();
    facilityEditOpeningHoursPage.init();
    $(document).on('change', 'select', function () {
        //Check whether option with value  exists
        var option = $("option[value='" + this.value + "']", this);
        if (option && option.length > 0) {
            option.attr('selected', true).siblings().removeAttr('selected');
        }
    });
    // enhance table saw to make responsive table
    $(document).trigger('enhance.tablesaw');
});

var FacilityEditOpeningHoursFunction =
    FacilityEditOpeningHoursFunction ||
    (function () {
        var blockFacilityEditOpeningHoursUI = function () {
            $('#loader').show();
        };
        var unBlockFacilityEditOpeningHoursUI = function () {
            $('#loader').hide();
        };
        var facilityEditOpeningHoursFillContentToModal = function (
            dialogId,
            header,
            content,
            openDialog,
            dialogType
        ) {
            var $dialogArea = $(dialogId);
            var $iconElement = $dialogArea.find('span.popup-type');
            if (dialogType) {
                $iconElement.removeClass('hidden');
                $iconElement.addClass(GroCommon.getModalIconClass(dialogType));
            } else {
                $iconElement.addClass('hidden');
            }

            $dialogArea.find('.lm__wide-modal__title').html(header);
            $dialogArea.find('p').append(content);
            $dialogArea.find('.btn-ok').on('click', function () {
                $dialogArea.addClass('hidden');
            });
            if (openDialog) {
                $dialogArea.removeClass('hidden');
            }
        };
        var facilityEditOpeningHoursClearContentToModal = function (dialogId) {
            var dialogArea = $(dialogId);
            dialogArea.find('span.alert-icon.popup-type').removeClass('warning success info-icon');
            dialogArea.find('.lm__wide-modal__title').html('');
            dialogArea.find('p').html('');
            dialogArea.find('.btn-ok').unbind('click');
        };
        var facilityOpeningHoursFillContentToConfirmDialog = function (header, content) {
            var dialogArea = $('#facilityEditOpeningHoursConfirmDialog');
            dialogArea.find('.modal-header-title').html(header);
            dialogArea.find('p').append(content);
            dialogArea.find('.btn-cancel').on('click', function () {
                dialogArea.hide();
            });
            dialogArea.find('.btn-ok').on('click', function () {
                dialogArea.hide();
            });
            dialogArea.show();
        };
        var facilityEditOpeningHoursClearContentToConfirmDialog = function () {
            var dialogArea = $('#facilityEditOpeningHoursConfirmDialog');
            dialogArea.find('.lm__wide-modal__title').html('');
            dialogArea.find('p').html('');
            dialogArea.find('.btn-ok').unbind('click');
            dialogArea.find('.btn-cancel').unbind('click');
        };
        var validateFacilityEditOpeningHours = function (openingHours, selector) {
            var result = true;
            for (var index = 0; index < openingHours.length; index++) {
                var openingHour = openingHours[index];
                if ($.trim(openingHour.FromHour) == '' && $.trim(openingHour.ToHour) != '') {
                    $('#' + selector + index).show();
                    result = false;
                } else if ($.trim(openingHour.FromHour) != '' && $.trim(openingHour.ToHour) == '') {
                    $('#' + selector + index).show();
                    result = false;
                } else if ($.trim(openingHour.FromHour) != '' && $.trim(openingHour.ToHour) != '') {
                    var fromHour = parseInt($.trim(openingHour.FromHour.replace(/_/g, '')));
                    var toHour = parseInt($.trim(openingHour.ToHour.replace(/_/g, '')));
                    if (fromHour == 0) fromHour = 2400;
                    if (toHour == 0) toHour = 2400;
                    if (toHour < fromHour) {
                        $('#' + selector + index).show();
                        result = false;
                    }
                }
            }
            return result;
        };
        var clearFacilityEditOpeningHoursValidation = function (selector) {
            for (var index = 0; index < 7; index++) {
                $('#' + selector + index).hide();
            }
        };
        var clearFacilityEditOpeningHoursValidations = function () {
            $('#harvestPeriodFromDateError').hide();
            clearFacilityEditOpeningHoursValidation('normalPeriodFromHourError_');
            clearFacilityEditOpeningHoursValidation('harvestPeriodFromHourError_');
            $('#sendFacilityOpeningHoursPreviewPhoneNumberError').hide();
            $('#extraPhoneNumberError').hide();
            $('#phoneBookingError').hide();
            $('#phoneAnsweringMachineError').hide();
            $('#faxError').hide();
            $('#emailError').hide();
            $('#websiteError').hide();
            $('#otherInformationError').hide();
            $('#harvestPeriodInformationError').hide();
        };
        var clearFacilityEditOpeningHoursPreviewPhoneNumber = function () {
            $('#FacilityOpeningHoursPreviewPhoneNumber').val('');
            $('#sendFacilityOpeningHoursPreviewBtn').addClass('disabled-btn');
        };
        var validateFacilityEditOpeningHoursSave = function (data) {
            var rePhone = /^((((0{2}?)|(\+){1})46)|0)7[\d]{8}/;
            var reEmail =
                /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            var reWebsite =
                /^(http(s)?:\/\/)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)$/;
            var result = true;
            clearFacilityEditOpeningHoursValidations();
            if (data) {
                var phone = $.trim($('#FacilityOpeningHoursPreviewPhoneNumber').val());
                if (
                    phone !== '' &&
                    (phone.length < 10 || phone.length > 15 || !rePhone.test(phone))
                ) {
                    result = false;
                    $('#sendFacilityOpeningHoursPreviewPhoneNumberError').show();
                }
                if (
                    $.trim(data.ExtraPhoneNumber) != '' &&
                    $.trim(data.ExtraPhoneNumber).length > 20
                ) {
                    result = false;
                    $('#extraPhoneNumberError').show();
                }
                if ($.trim(data.PhoneBooking) != '' && $.trim(data.PhoneBooking).length > 50) {
                    result = false;
                    $('#phoneBookingError').show();
                }
                if (
                    $.trim(data.PhoneAnsweringMachine) != '' &&
                    $.trim(data.PhoneAnsweringMachine).length > 20
                ) {
                    result = false;
                    $('#phoneAnsweringMachineError').show();
                }
                if ($.trim(data.Fax) != '' && $.trim(data.Fax).length > 20) {
                    result = false;
                    $('#faxError').show();
                }
                var email = $.trim(data.Email);
                if (email !== '' && (email.length > 255 || !reEmail.test(email))) {
                    result = false;
                    $('#emailError').show();
                }
                var website = $.trim(data.Website);
                if (website !== '' && (website.length > 255 || !reWebsite.test(website))) {
                    result = false;
                    $('#websiteError').show();
                }
                if (
                    $.trim(data.OtherInformation) != '' &&
                    $.trim(data.OtherInformation).length > 120
                ) {
                    result = false;
                    $('#otherInformationError').show();
                }
                if (
                    $.trim(data.HarvestPeriod.FromDate) == '' &&
                    $.trim(data.HarvestPeriod.ToDate) != ''
                ) {
                    result = false;
                    $('#harvestPeriodFromDateError').show();
                } else if (
                    $.trim(data.HarvestPeriod.FromDate) != '' &&
                    $.trim(data.HarvestPeriod.ToDate) == ''
                ) {
                    result = false;
                    $('#harvestPeriodFromDateError').show();
                } else if (
                    $.trim(data.HarvestPeriod.FromDate) != '' &&
                    $.trim(data.HarvestPeriod.ToDate) != ''
                ) {
                    var fromDate = new Date(data.HarvestPeriod.FromDate);
                    var toDate = new Date(data.HarvestPeriod.ToDate);
                    if (toDate < fromDate) {
                        result = false;
                        $('#harvestPeriodFromDateError').show();
                    }
                }
                var harvestPeriodOtherInformation = data.HarvestPeriod.OtherInformation;
                if (
                    $.trim(harvestPeriodOtherInformation) !== '' &&
                    harvestPeriodOtherInformation.length > 120
                ) {
                    result = false;
                    $('#harvestPeriodOtherInformationError').show();
                }
                var areNormalPeriodOpeningHoursValid = validateFacilityEditOpeningHours(
                    data.NormalPeriod.OpeningHours,
                    'normalPeriodFromHourError_'
                );
                var areHarvestPeriodOpeningHoursValid = validateFacilityEditOpeningHours(
                    data.HarvestPeriod.OpeningHours,
                    'harvestPeriodFromHourError_'
                );
                result =
                    result && areNormalPeriodOpeningHoursValid && areHarvestPeriodOpeningHoursValid;
            }

            return result;
        };
        var disableFacilityEditOpeningHoursButtons = function () {
            $('#saveFacilityOpeningHoursInfoBtn').addClass('disabled-btn');
            $('#saveAndSendFacilityOpeningHoursInfoBtn').addClass('disabled-btn');
            $('#sendFacilityOpeningHoursPreviewBtn').addClass('disabled-btn');
        };
        var enableFacilityEditOpeningHoursButtons = function () {
            $('#saveFacilityOpeningHoursInfoBtn').removeClass('disabled-btn');
            $('#saveAndSendFacilityOpeningHoursInfoBtn').removeClass('disabled-btn');
            $('#sendFacilityOpeningHoursPreviewBtn').removeClass('disabled-btn');
        };

        return {
            blockFacilityEditOpeningHoursUI: blockFacilityEditOpeningHoursUI,
            unBlockFacilityEditOpeningHoursUI: unBlockFacilityEditOpeningHoursUI,
            facilityEditOpeningHoursFillContentToModal: facilityEditOpeningHoursFillContentToModal,
            facilityEditOpeningHoursClearContentToModal:
                facilityEditOpeningHoursClearContentToModal,
            facilityOpeningHoursFillContentToConfirmDialog:
                facilityOpeningHoursFillContentToConfirmDialog,
            facilityEditOpeningHoursClearContentToConfirmDialog:
                facilityEditOpeningHoursClearContentToConfirmDialog,
            validateFacilityEditOpeningHoursSave: validateFacilityEditOpeningHoursSave,
            clearFacilityEditOpeningHoursValidations: clearFacilityEditOpeningHoursValidations,
            clearFacilityEditOpeningHoursPreviewPhoneNumber:
                clearFacilityEditOpeningHoursPreviewPhoneNumber,
            enableFacilityEditOpeningHoursButtons: enableFacilityEditOpeningHoursButtons,
            disableFacilityEditOpeningHoursButtons: disableFacilityEditOpeningHoursButtons,
        };
    })();

var FacilityEditOpeningHoursPage = function () {
    var dialogType = GroCommon.modalInfoClass;

    var hideFacilityEditOpeningHoursInformation = function () {
        $('.js-hide-show-facility-opening-hours-information').hide();
    };

    var showFacilityEditOpeningHoursInformation = function () {
        $('.js-hide-show-facility-opening-hours-information').show();
    };
    var getCurrentlySelectedFacilityType = function () {
        return parseInt($('#FacilityType').val());
    };
    var getCurrentlySelectedFacilityTypeName = function () {
        return $('.facility-type-dropdown :selected').text();
    };
    var getCurrentlySelectedFacility = function () {
        return $('#SelectedFacilityId').val().split('_')[0];
    };
    var getCurrentlySelectedFacilityWarehouseType = function () {
        return $('#SelectedFacilityId').val().split('_')[1];
    };
    var getCurrentlySelectedFacilityWarehouseSubType = function () {
        return $('#SelectedFacilityId').val().split('_')[2];
    };
    var getCurrentlySelectedFacilityName = function () {
        return $('.facility-dropdown :selected').text();
    };
    var getShowFacilityOpeningHoursInfo = function () {
        return $("input[name='ShowFacilityOpeningHoursInfo']:checked").val() == '1' ? true : false;
    };
    var getFacilityEditOpeningHoursPreviewPhoneNumber = function () {
        return $('#FacilityOpeningHoursPreviewPhoneNumber').val();
    };
    var getFacilityEditOpeningHoursSelectedTab = function () {
        return $('.tab-navigation__tab-content.is-active').data('tab');
    };
    var isFacilityEditOpeningHoursHarvestPeriodTabSelected = function () {
        return getFacilityEditOpeningHoursSelectedTab() == 'updatedOpeningHours';
    };
    var addFacilityEditOpeningHoursUploadPopupEvent = function () {
        $(document).on('click', function () {
            $('.popup-sub').fadeOut();
        });

        //$(".popup-sub").click(function () { return false; });
        $('.lm__avatar .lm__avatar__upload-btn').click(function () {
            var popupSub = $(this).parent();
            if (popupSub.has('.popup-sub')) {
                popupSub.find('.popup-sub').fadeToggle();
            }
            return false;
        });
    };
    function getFacilityEditOpeningHoursImageUploadSettings() {
        return {
            fileSelector: '#facility-avatar__file',
            previewImgSelector: '#facility-avatar',
            uploadBtnSelector: '#facility-uploadBtn',
            cancelUploadBtnSelector: '#facility-cancelUpload',
            linkSelector: '#facility-link',
            handleUrl: '/api/facility-edit-opening-hours/upload-facility-opening-hours-image',
            deleteLinkSelector: '#facility-deleteBtn',
            handleDeleteUrl: '/api/facility-edit-opening-hours/delete-facility-opening-hours-image',
            isNeedToUpdateHeader: false,
            messages: {
                confirmationDialogSelector: '#dialog-facility-opening-hours-confirmation',
            },
        };
    }
    var initFacilityEditOpeningHoursImageUploadEvent = function () {
        addFacilityEditOpeningHoursUploadPopupEvent();
        //Init for Customer picture
        var facilityEditOpeningHoursImageUploadSettings =
            getFacilityEditOpeningHoursImageUploadSettings();
        var facilityEditOpeningHoursImageUploadModule = UploadImageModule(
            facilityEditOpeningHoursImageUploadSettings
        );
        facilityEditOpeningHoursImageUploadModule.initDataForRequest([
            { key: 'url', value: $('#facility-avatar').attr('src') },
        ]);
        facilityEditOpeningHoursImageUploadModule.initUploadFile();
        facilityEditOpeningHoursImageUploadModule.initDeleteFile();
    };
    var loaderWrapper = '<div class="loader-wrapper"><div class="loader"></div></div>';
    var requests = [];

    var fetchFacilitiesByType = function () {
        var facilityType = getCurrentlySelectedFacilityTypeName();
        hideFacilityEditOpeningHoursInformation();
        FacilityEditOpeningHoursFunction.blockFacilityEditOpeningHoursUI();
        $.each(requests, function (index, request) {
            request.abort();
        });
        $('#facility-option > select').html('');
        $('.facilities').addClass('hidden');
        requests = [];
        var facilitiesUrl = '/api/facility-edit-opening-hours/facilities-by-type';
        var parameters = {
            selectedFacilityType: facilityType,
        };
        var facilitiesDeferred = $.ajax({
            type: 'Get',
            url: facilitiesUrl,
            async: true,
            cache: false,
            data: parameters,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response) {
                if (response) {
                    var facilities =
                        typeof response.facilities == 'string'
                            ? JSON.parse(response.facilities)
                            : response.facilities;
                    $.each(facilities, function (index, facility) {
                        $('#facility-option > select').append(
                            "<option value='" + facility.Value + "'>" + facility.Text + '</option>'
                        );
                    });
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching facilities!' +
                        '</br>' +
                        exception
                );
                $('#facilities').html('<h2> facilities Saknas</h2>');
            },
        });

        requests.push(facilitiesDeferred);
        $.when.apply($, requests).then(function (data) {
            FacilityEditOpeningHoursFunction.unBlockFacilityEditOpeningHoursUI();
            $('.facilities').removeClass('hidden');
        });
    };
    var fetchFacilityOpeningHoursInformation = function () {
        var selectedFacilityId = getCurrentlySelectedFacility();
        hideFacilityEditOpeningHoursInformation();
        FacilityEditOpeningHoursFunction.blockFacilityEditOpeningHoursUI();
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        var facilityInformationUrl =
            '/api/facility-edit-opening-hours/fetch-facility-opening-hours';
        var parameters = {
            facilityId: selectedFacilityId,
            isInternal: $.trim($("input[id='IsInternal']").val()),
        };
        var facilityInformationDeferred = $.ajax({
            type: 'Get',
            url: facilityInformationUrl,
            async: true,
            cache: false,
            data: parameters,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data) {
                if (data) {
                    if (data.facilityInformation && data.facilityInformation.length !== 0) {
                        $('.facilityOpeningHoursInformationPlaceHolder').html(
                            data.facilityInformation
                        );
                        /* little fade in effect */
                        $('.facilityOpeningHoursInformationPlaceHolder').fadeIn('fast');
                    }
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching FacilityInformation for editing!' +
                        '</br>' +
                        exception
                );
                $('.facilityOpeningHoursInformationPlaceHolder').html(
                    '<h2>Failed to fetch facility information for editing</h2>'
                );
            },
        });
        requests.push(facilityInformationDeferred);
        $.when.apply($, requests).then(function (data) {
            $('.selected-facility-name').html(getCurrentlySelectedFacilityName());
            initFacilityEditOpeningHoursImageUploadEvent();
            FacilityEditOpeningHoursFunction.unBlockFacilityEditOpeningHoursUI();
            showFacilityEditOpeningHoursInformation();
        });
    };
    var getFacilityOpeningHours = function (fromHourSelector, toHourSelector, informationSelector) {
        var openingHours = [];
        var daysName = ['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag', 'Söndag'];
        for (var index = 0; index < 7; index++) {
            var openingHour = {
                Day: daysName[index],
                FromHour: $.trim($('#' + fromHourSelector + index).val()),
                ToHour: $.trim($('#' + toHourSelector + index).val()),
                Information: $('#' + informationSelector + index).val(),
            };
            openingHours.push(openingHour);
        }
        return openingHours;
    };

    var validateFacilityOpeningHours = function (openingHours, period, arr) {
        for (var index = 0; index < openingHours.length; index++) {
            var openingHour = openingHours[index];
            if ($.trim(openingHour.FromHour) == '' && $.trim(openingHour.ToHour) != '') {
                arr[arr.length] =
                    '<li>' + period + ': ' + openingHour.Day + ' Från tim måste ange.</li>';
            } else if ($.trim(openingHour.FromHour) != '' && $.trim(openingHour.ToHour) == '') {
                arr[arr.length] =
                    '<li>' + period + ': ' + openingHour.Day + ' Till tim måste ange.</li>';
            } else if ($.trim(openingHour.FromHour) != '' && $.trim(openingHour.ToHour) != '') {
                var fromHour = parseInt($.trim(openingHour.FromHour.replace(/_/g, '')));
                var toHour = parseInt($.trim(openingHour.ToHour.replace(/_/g, '')));
                if (fromHour == 0) fromHour = 2400;
                if (toHour == 0) toHour = 2400;
                if (toHour < fromHour) {
                    arr[arr.length] =
                        '<li>' +
                        period +
                        ': ' +
                        openingHour.Day +
                        ' Till tim måste vara större än Från tim.</li>';
                }
            }
        }
    };
    var getFacilityOpeningHoursInformationPayload = function () {
        var payload = {
            FacilityId: getCurrentlySelectedFacility(),
            FacilityName: getCurrentlySelectedFacilityName(),
            WarehouseType: getCurrentlySelectedFacilityWarehouseType(),
            WarehouseSubType: getCurrentlySelectedFacilityWarehouseSubType(),
            FacilityType: getCurrentlySelectedFacilityType(),
            ShowFacilityInfo: getShowFacilityOpeningHoursInfo(),
            ExtraPhoneNumber: $.trim($("input[id='ExtraPhoneNumber']").val()),
            PhoneBooking: $.trim($("input[id='PhoneBooking']").val()),
            PhoneAnsweringMachine: $.trim($("input[id='PhoneAnsweringMachine']").val()),
            Fax: $.trim($("input[id='Fax']").val()),
            Email: $.trim($("input[id='Email']").val()),
            Website: $.trim($("input[id='Website']").val()),
            OtherInformation: $.trim($("textArea[id='OtherInformation']").val()),
            NormalPeriod: {
                OpeningHours: getFacilityOpeningHours(
                    'NormalPeriodFromHour_',
                    'NormalPeriodToHour_',
                    'NormalPeriodInformation_'
                ),
            },
            HarvestPeriod: {
                FromDate: $.trim($('#HarvestPeriodFromDate').val()),
                ToDate: $.trim($('#HarvestPeriodToDate').val()),
                OtherInformation: $.trim($('#HarvestPeriodOtherInformation').val()),
                OpeningHours: getFacilityOpeningHours(
                    'HarvestPeriodFromHour_',
                    'HarvestPeriodToHour_',
                    'HarvestPeriodInformation_'
                ),
            },
            FacilityImageUrl: $('#facility-avatar').attr('src'),
            FacilityOwnerId: $.trim($("input[id='FacilityOwner']").val()),
            FacilityInfoSource: $.trim($("input[id='FacilityInfoSource']").val()),
            FacilityPropertyType: $.trim($("input[id='FacilityPropertyType']").val()),
        };
        if ($.trim(payload.WarehouseType) == '') payload.WarehouseType = 'Z1';
        if ($.trim(payload.WarehouseSubType) == '') payload.WarehouseSubType = '1';
        return payload;
    };
    var validateSendingFacilityOpeningHoursInformationPreview = function (phone, arr) {
        var rePhone = /^((((0{2}?)|(\+){1})46)|0)7[\d]{8}/;

        if (
            $.trim(phone) !== '' &&
            (phone.length < 10 || phone.length > 15 || !rePhone.test(phone))
        ) {
            arr[arr.length] = '<li>Ange ett giltigt mobilnummer for test avisering.</li>';
        }
        return arr;
    };
    var validateSaveFacilityOpeningHoursInformation = function (data) {
        var arr = [];

        var reEmail =
            /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        var reWebsite =
            /^(http(s)?:\/\/)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)$/;

        if ($.trim(data.FacilityId) == '') {
            arr[arr.length] = '<li>FacilityId saknar värde.</li>';
        }
        if ($.trim(data.ExtraPhoneNumber) != '' && $.trim(data.ExtraPhoneNumber).length > 20) {
            arr[arr.length] = '<li>Extra telefonnummer kan vara max 20 tecken.</li>';
        }
        if ($.trim(data.PhoneBooking) != '' && $.trim(data.PhoneBooking).length > 50) {
            arr[arr.length] = '<li>Tidsbokning kan vara max 50 tecken.</li>';
        }
        if (
            $.trim(data.PhoneAnsweringMachine) != '' &&
            $.trim(data.PhoneAnsweringMachine).length > 20
        ) {
            arr[arr.length] = '<li>Telefonsvarare kan vara max 20 tecken.</li>';
        }
        if ($.trim(data.Fax) != '' && $.trim(data.Fax).length > 20) {
            arr[arr.length] = '<li>Fax kan vara max 20 tecken.</li>';
        }
        var email = $.trim(data.Email);
        if (email !== '' && (email.length > 255 || !reEmail.test(email))) {
            arr[arr.length] = '<li>Ange ett giltigt e-post adress.</li>';
        }
        var website = $.trim(data.Website);
        if (website !== '' && (website.length > 255 || !reWebsite.test(website))) {
            arr[arr.length] = '<li>Ange ett giltigt webbplats adress.</li>';
        }
        if ($.trim(data.OtherInformation) != '' && $.trim(data.OtherInformation).length > 120) {
            arr[arr.length] = '<li>Övrigt kan vara max 120 tecken.</li>';
        }
        if ($.trim(data.HarvestPeriod.FromDate) == '' && $.trim(data.HarvestPeriod.ToDate) != '') {
            arr[arr.length] = '<li>Från datum måste ange.</li>';
        } else if (
            $.trim(data.HarvestPeriod.FromDate) != '' &&
            $.trim(data.HarvestPeriod.ToDate) == ''
        ) {
            arr[arr.length] = '<li>Till datum måste ange.</li>';
        } else if (
            $.trim(data.HarvestPeriod.FromDate) != '' &&
            $.trim(data.HarvestPeriod.ToDate) != ''
        ) {
            var fromDate = new Date(data.HarvestPeriod.FromDate);
            var toDate = new Date(data.HarvestPeriod.ToDate);
            if (toDate < fromDate) {
                arr[arr.length] = '<li>Till datum måste vara större än Från datum.</li>';
            }
        }
        if (
            $.trim(data.HarvestPeriod.OtherInformation) != '' &&
            $.trim(data.HarvestPeriod.OtherInformation).length > 120
        ) {
            arr[arr.length] = '<li>Info ändrade öppettider kan vara max 120 tecken.</li>';
        }
        validateFacilityOpeningHours(data.NormalPeriod.OpeningHours, 'Normal Period', arr);
        validateFacilityOpeningHours(data.HarvestPeriod.OpeningHours, 'Harvest Period', arr);
        validateSendingFacilityOpeningHoursInformationPreview(
            getFacilityEditOpeningHoursPreviewPhoneNumber(),
            arr
        );
        return arr;
    };
    var saveFacilityOpeningHoursInformation = function (
        e,
        notifySubscribers,
        notifySubscribersForEffectivePeriod
    ) {
        FacilityEditOpeningHoursFunction.clearFacilityEditOpeningHoursPreviewPhoneNumber();
        var facilityInformationPayload = getFacilityOpeningHoursInformationPayload();

        if (
            FacilityEditOpeningHoursFunction.validateFacilityEditOpeningHoursSave(
                facilityInformationPayload
            )
        ) {
            FacilityEditOpeningHoursFunction.disableFacilityEditOpeningHoursButtons();
            FacilityEditOpeningHoursFunction.blockFacilityEditOpeningHoursUI();
            $.ajax({
                url: '/api/facility-edit-opening-hours/save-facility-opening-hours',
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify({
                    facilityInformationSaveRequest: facilityInformationPayload,
                    notifySubscribers: notifySubscribers,
                    notifySubscribersForEffectivePeriod: notifySubscribersForEffectivePeriod,
                }),
                cache: false,
                success: function (response) {
                    FacilityEditOpeningHoursFunction.enableFacilityEditOpeningHoursButtons();
                    FacilityEditOpeningHoursFunction.unBlockFacilityEditOpeningHoursUI();
                    FacilityEditOpeningHoursFunction.facilityEditOpeningHoursClearContentToModal(
                        '#facilityEditOpeningHoursDialogArea'
                    );
                    if (response) {
                        FacilityEditOpeningHoursFunction.facilityEditOpeningHoursFillContentToModal(
                            '#facilityEditOpeningHoursDialogArea',
                            'Anläggning uppdaterad',
                            notifySubscribers
                                ? 'Informationen om anläggningen är uppdaterad och meddelande har skickats till LM2-användare som prenumererat på uppdateringar för ' +
                                      facilityInformationPayload.FacilityName
                                : '',
                            true,
                            dialogType.error
                        );
                    } else {
                        FacilityEditOpeningHoursFunction.facilityEditOpeningHoursFillContentToModal(
                            '#facilityEditOpeningHoursDialogArea',
                            'Anläggning uppdateringsfel',
                            notifySubscribers
                                ? 'Det uppstode fel vid anläggning uppdatering och meddelande-utskicket.'
                                : 'Fel uppstod när anläggning skulle uppdateras.',
                            true,
                            dialogType.error
                        );
                    }
                },
                error: function () {
                    FacilityEditOpeningHoursFunction.enableFacilityEditOpeningHoursButtons();
                    FacilityEditOpeningHoursFunction.unBlockFacilityEditOpeningHoursUI();
                    FacilityEditOpeningHoursFunction.facilityEditOpeningHoursClearContentToModal(
                        '#facilityEditOpeningHoursDialogArea'
                    );
                    FacilityEditOpeningHoursFunction.facilityEditOpeningHoursFillContentToModal(
                        '#facilityEditOpeningHoursDialogArea',
                        'Uppdateringsfel',
                        notifySubscribers
                            ? 'Det uppstode fel vid öppettider uppdatering och meddelande-utskicket.'
                            : 'Fel uppstod när öppettider skulle uppdateras.',
                        true,
                        dialogType.error
                    );
                },
            });
        } else {
            var errors = validateSaveFacilityOpeningHoursInformation(facilityInformationPayload);
            if (errors.length > 0) {
                FacilityEditOpeningHoursFunction.facilityEditOpeningHoursClearContentToModal(
                    '#facilityEditOpeningHoursDialogArea'
                );
                var errorContent = $('<p></p>').append('<ul>' + errors.join('') + '</ul>');
                FacilityEditOpeningHoursFunction.facilityEditOpeningHoursFillContentToModal(
                    '#facilityEditOpeningHoursDialogArea',
                    '',
                    errorContent,
                    true,
                    dialogType.error
                );
            }
        }
        return false;
    };
    var sendFacilityOpeningHoursInfoPreview = function (e) {
        var facilityOpeningHoursInfoPayload = getFacilityOpeningHoursInformationPayload();
        var phoneNumber = getFacilityEditOpeningHoursPreviewPhoneNumber();
        if (
            FacilityEditOpeningHoursFunction.validateFacilityEditOpeningHoursSave(
                facilityOpeningHoursInfoPayload
            )
        ) {
            FacilityEditOpeningHoursFunction.disableFacilityEditOpeningHoursButtons();
            FacilityEditOpeningHoursFunction.blockFacilityEditOpeningHoursUI();
            $('#send-message-loader').html(loaderWrapper);
            $.ajax({
                url: '/api/facility-edit-opening-hours/send-facility-opening-hours-preview',
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify({
                    facilityInformationSaveRequest: facilityOpeningHoursInfoPayload,
                    phoneNumber: $.trim(phoneNumber),
                    notifySubscribersForEffectivePeriod:
                        isFacilityEditOpeningHoursHarvestPeriodTabSelected(),
                }),
                cache: false,
                success: function (response) {
                    $('#send-message-loader').html('');
                    FacilityEditOpeningHoursFunction.enableFacilityEditOpeningHoursButtons();
                    FacilityEditOpeningHoursFunction.unBlockFacilityEditOpeningHoursUI();
                    FacilityEditOpeningHoursFunction.facilityEditOpeningHoursClearContentToModal(
                        '#facilityEditOpeningHoursDialogArea'
                    );
                    if (response) {
                        FacilityEditOpeningHoursFunction.facilityEditOpeningHoursFillContentToModal(
                            '#facilityEditOpeningHoursDialogArea',
                            'Sms skickat',
                            '',
                            true,
                            dialogType.error
                        );
                    } else {
                        FacilityEditOpeningHoursFunction.facilityEditOpeningHoursFillContentToModal(
                            '#facilityEditOpeningHoursDialogArea',
                            'Kunde ej skicka SMS',
                            'Fel uppstod när öppettider skulle skickas.',
                            true,
                            dialogType.error
                        );
                    }
                },
                error: function () {
                    $('#send-message-loader').html('');
                    FacilityEditOpeningHoursFunction.enableFacilityEditOpeningHoursButtons();
                    FacilityEditOpeningHoursFunction.unBlockFacilityEditOpeningHoursUI();
                    FacilityEditOpeningHoursFunction.facilityEditOpeningHoursClearContentToModal(
                        '#facilityEditOpeningHoursDialogArea'
                    );
                    FacilityEditOpeningHoursFunction.facilityEditOpeningHoursFillContentToModal(
                        '#facilityEditOpeningHoursDialogArea',
                        'Kunde ej skicka SMS',
                        'Fel uppstod när öppettider skulle skickas.',
                        true,
                        dialogType.error
                    );
                },
            });
        } else {
            var errors = validateSaveFacilityOpeningHoursInformation(
                facilityOpeningHoursInfoPayload
            );
            if (errors.length > 0) {
                FacilityEditOpeningHoursFunction.facilityEditOpeningHoursClearContentToModal(
                    '#facilityEditOpeningHoursDialogArea'
                );
                var errorContent = $('<p></p>').append('<ul>' + errors.join('') + '</ul>');
                FacilityEditOpeningHoursFunction.facilityEditOpeningHoursFillContentToModal(
                    '#facilityEditOpeningHoursDialogArea',
                    '',
                    errorContent,
                    true,
                    dialogType.error
                );
            }
        }
        return false;
    };
    var fetchFacilitiesByTypeEvent = function () {
        $('.facility-type-dropdown').on('change', function () {
            FacilityEditOpeningHoursFunction.clearFacilityEditOpeningHoursValidations();
            FacilityEditOpeningHoursFunction.facilityEditOpeningHoursClearContentToModal(
                '#facilityEditOpeningHoursDialogArea'
            );
            FacilityEditOpeningHoursFunction.clearFacilityEditOpeningHoursPreviewPhoneNumber();
            fetchFacilitiesByType();
        });
    };
    var fetchFacilityOpeningHoursInformationEvent = function () {
        $('.facility-dropdown').on('change', function () {
            FacilityEditOpeningHoursFunction.clearFacilityEditOpeningHoursValidations();
            FacilityEditOpeningHoursFunction.facilityEditOpeningHoursClearContentToModal(
                '#facilityEditOpeningHoursDialogArea'
            );
            FacilityEditOpeningHoursFunction.clearFacilityEditOpeningHoursPreviewPhoneNumber();
            fetchFacilityOpeningHoursInformation();
        });
    };
    var sendFacilityOpeningHoursInfoPreviewTextChangeEvent = function () {
        $('#FacilityOpeningHoursPreviewPhoneNumber').on('change paste keyup', function () {
            var phone = $(this).val();
            $('#sendFacilityOpeningHoursPreviewPhoneNumberError').hide();
            if ($.trim(phone) !== '') {
                $('#sendFacilityOpeningHoursPreviewBtn').removeClass('disabled-btn');
            } else {
                $('#sendFacilityOpeningHoursPreviewBtn').addClass('disabled-btn');
            }
        });
    };
    var saveFacilityOpeningHoursInformationEvent = function () {
        $('#saveFacilityOpeningHoursInfoBtn').click(function (e) {
            saveFacilityOpeningHoursInformation(e, false, false);
        });
    };
    var saveAndSendFacilityOpeningHoursInformationEvent = function () {
        $('#saveAndSendFacilityOpeningHoursInfoBtn').click(function (e) {
            var isHarvestPeriodSelected = isFacilityEditOpeningHoursHarvestPeriodTabSelected();
            var content = $('<p></p>').append(
                'Vill du avisera <b>' +
                    (isHarvestPeriodSelected ? 'Ändrade Öppettider' : 'Öppettider') +
                    '</b> till alla prenumeranter på <b>' +
                    getCurrentlySelectedFacilityName() +
                    '</b>?'
            );
            FacilityEditOpeningHoursFunction.facilityEditOpeningHoursClearContentToConfirmDialog();
            FacilityEditOpeningHoursFunction.facilityOpeningHoursFillContentToConfirmDialog(
                '',
                content
            );
            $('#facilityEditOpeningHoursConfirmDialog')
                .find('.btn-ok')
                .on('click', function () {
                    saveFacilityOpeningHoursInformation(
                        e,
                        true,
                        isHarvestPeriodSelected ? true : false
                    );
                });
            $('#facilityEditOpeningHoursConfirmDialog')
                .find('.btn-cancel')
                .on('click', function () {
                    saveFacilityOpeningHoursInformation(e, false, false);
                });
        });
    };
    var sendFacilityOpeningHoursInfoPreviewEvent = function () {
        $('#sendFacilityOpeningHoursPreviewBtn').click(function (e) {
            sendFacilityOpeningHoursInfoPreview(e);
        });
    };

    var init = function () {
        fetchFacilitiesByTypeEvent();
        fetchFacilityOpeningHoursInformationEvent();
        saveFacilityOpeningHoursInformationEvent();
        saveAndSendFacilityOpeningHoursInformationEvent();
        sendFacilityOpeningHoursInfoPreviewEvent();
        sendFacilityOpeningHoursInfoPreviewTextChangeEvent();
    };
    return {
        init: init,
    };
};
